export const SET_ERROR = "SET_ERROR";

export const SET_WARNING_WIDTH = "SET_WARNING_WIDTH";
export const SET_WARNING_HEIGHT = "SET_WARNING_HEIGHT";